import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean } from '../../../../Fct/generics';
export var SetApprovalForAll = createPlugin({
    protocol: 'ERC721',
    type: 'ACTION',
    method: 'setApprovalForAll',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc721' }),
                methodParams: {
                    operator: new FctAddress({}),
                    _approved: new FctBoolean({}),
                },
            },
            output: {},
        });
    },
});
